import React from 'react';
import { AppWindowIcon, RotateCcwIcon, ShoppingBagIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { COST_STATS } from '../../data/content';
const ICONS = [AppWindowIcon, RotateCcwIcon, ShoppingBagIcon];
export function SocialStats() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-222" data-mp="1gju0360eqs5r">
      <div className="mx-auto max-w-5xl" data-id="element-223" data-mp="1ggem66igzp5x">
        <Reveal className="text-center" data-id="element-224" data-mp="1lgsttng5sx3f">
          <SectionBadge data-id="element-225" data-mp="1lfrg1b7rdwi0">El problema real</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-226" data-mp="1qfx1g9nfqmrn">
            El verdadero costo de <span className="u-mark" data-id="element-227" data-mp="1v8gpy1nnv2b8">tejer sin una guía</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-cocoa-soft sm:text-base" data-id="element-228" data-mp="1z7yz6064doy8">
            No es solamente el tiempo que perdés. Es comprar materiales que después no sirven, empezar proyectos que
            quedan a medias y no saber cómo convertir lo que hacés en algo que{' '}
            <strong className="font-bold text-cocoa" data-id="element-229" data-mp="3b96i6k473otc">realmente puedas usar o vender</strong>.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-8 sm:grid-cols-3 sm:gap-0 sm:divide-x sm:divide-sand-line" data-id="element-230" data-mp="367zeox935bsh">
          {COST_STATS.map((stat, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <Reveal key={stat.title} delay={index * 60} as="article" className="sm:px-7 first:sm:pl-0 last:sm:pr-0" data-id="element-231" data-mp="2xap1h6cpjckx" data-mpi={index}>
                <Icon className="h-5 w-5 text-terra" aria-hidden="true" data-id="element-232" data-mp="3px9pbwtz56jq" />
                <p className="mt-4 font-display text-6xl leading-none text-terra" data-id="element-233" data-mp="3py2y13chu64i">{stat.value}</p>
                <p className="mt-2 text-xs font-extrabold uppercase tracking-[0.16em] text-cocoa-dim" data-id="element-234" data-mp="3l4qakwjjw5dc">{stat.unit}</p>
                <h3 className="mt-4 text-base font-bold text-cocoa" data-id="element-235" data-mp="3g5nh89cxnnl7">{stat.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-cocoa-soft" data-id="element-236" data-mp="hjkn8tv64ch7">{stat.desc}</p>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}